require('./angular-sanitize');
module.exports = 'ngSanitize';



// WEBPACK FOOTER //
// ./src/libs/angular-sanitize/index.js